import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  padding: ${({ theme }) => `${theme.spacing[2]}px ${theme.spacing[4]}px`};
  background-color: ${({ theme }) => theme.colors.neutral.neutral[2]};
`;
